"use strict";

class PresenterFormCtrl {

    constructor($state, $stateParams, Presenter, $mdToast, $mdDialog, $http, $rootScope, widgets) {

        this.$state = $state;
        this.$rootScope = $rootScope;
        this._Presenter = Presenter;
        this.buttonDisabled = false;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$http = $http;
        this.$stateParams = $stateParams;
        this.widgets = widgets;

        this.customFieldsRaw = [];
        this.customFields = {};
        this.formdata = {
            active: true
        };

        this.checkForRelatedPresenters = {};

        if ($stateParams.id) {
            //force the id in formdata before loading custom fields
            this.formdata.id = $stateParams.id;
            this.getModelTypes().then(() => {
                Presenter.get({id: $stateParams.id}, (data) => {
                    angular.extend(this.formdata, data);
                    this.formdata.model_type_id = data.model_type_id;
                });
            });
        } else {
            this.getModelTypes().then(() => {
                this.formdata.model_type_id = this.customFieldsRaw[0].id;
            });
        }

        if ($stateParams.name) {
            this.formdata.name = $stateParams.name;
        }

        this.getPresenterUrl = function () {
            if (this.formdata.name && this.formdata.name.length > 3) {
                let presenterId;
                if (this.formdata.id) {
                    presenterId = this.formdata.id;
                } else {
                    presenterId = 0;
                }
                let presenter = encodeURIComponent(this.formdata.name.replace('/', ''));
                let url = '/presenters/unique_presenter/' + presenter + '/' + presenterId;
                return url;
            }
        }.bind(this);

        this.checkRelatedPresenters = () => {
            this.checkForRelatedPresenters.update();
        };
    }


    getModelTypes() {
        return this.$http.get('/modeltypes/presenter', {cache: true}).then((response) => {
            this.customFieldsRaw = response.data.presenter;
            response.data.presenter.forEach((data) => {
                this.customFields[data.id] = data.fields;
            });
            if (this.customFieldsRaw.length < 2) {
                this.formdata.model_type_id = this.customFieldsRaw[0].id;
            }
            return response.data;
        });
    }


    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate(date) {
        return date ? new Date(date) : new Date();
    }


    cancel() {

        this.$state.go('presenters');
    }


    save($valid) {
        //Check if form is valid
        if (!$valid) {
            return;
        }

        //Disable button
        this.buttonDisabled = true;

        this.widgets.saveWidgetsForTypeId('presenter-' + this.formdata.id).then(() => {

            let modelData = _.clone(this.formdata)
            modelData.field_values = this.setCustomFieldValues(modelData)

            //Save presenter object
            this._Presenter.save(modelData, data => {
                //Get the right type
                let type = this.formdata.id ? 'saved' : 'create';

                //Show notifications
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.' + type + '?object=presenter&title=' + this.formdata.name, //@trans('labels.presenter')
                    hideDelay: 3000,
                    position: ('top right')
                });

                if (this.$stateParams.fromOtherSource) {
                    //Broadcast presenter (back to item view)
                    this.$rootScope.$broadcast('made_new_presenter', data);

                    //Return to previous view
                    this.back();

                } else {
                    //Reload update view
                    this.$state.go('presenters.update', {id: data.id}, {'reload': true});

                }
            });
        });
    }

    setCustomFieldValues(rawData) {
        let fieldValues = {};
        if (rawData && rawData.field_values) {
            for (const [key, value] of Object.entries(rawData.field_values)) {
                fieldValues[key] = value;
            }
        }
        return fieldValues
    }

    //Modalbox
    showRevisions(ev) {

        this.$http.get('/revisions/presenters/' + this.$stateParams.id).then(revisions => {

            this.$mdDialog.show({

                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {

                    revisions: revisions.data
                }
            }).then((values) => {
                this.formdata.name = values.name;
                this.formdata.active = values.active;
                this.formdata.model_type_id = values.model_type_id;
                this.formdata.field_values = JSON.parse(values.field_values);
            }).catch(() => {
            });
        });
    }


    isUpdate() {
        return this.formdata.id ? true : false;
    }


    //cancel button when creating presenter in epg
    back() {
        this.$state.go('^');
    }
}

PresenterFormCtrl.$inject = ['$state', '$stateParams', 'Presenter', '$mdToast', '$mdDialog', '$http', '$rootScope', 'widgets'];

module.exports = PresenterFormCtrl;
